import React from 'react'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import RepaymentListOldUI from '../../../components/superUser/loanList/RepaymentListOldUI'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'

const RepaymentListOldPageUI = ({context, errorList, repaymentList, nextRepaymentList, totals, onRefreshClick}) =>
  <SuperUserPageSF context={context} className='pg_su_rp_lst' topnav='loans'
    headerText='EMI Tracker (Old)' centered={!repaymentList && !errorList}
  >
    {
      !repaymentList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      repaymentList && repaymentList.length !== 0 &&
      <div className='g_m_top_50'>
        <RepaymentListOldUI context={context} repaymentList={repaymentList}
          totals={totals} onRefreshClick={onRefreshClick} next={false}
        />
      </div>
    }
    {
      nextRepaymentList && nextRepaymentList.length !== 0 &&
      <div className='g_m_top_50'>
        <RepaymentListOldUI context={context} repaymentList={nextRepaymentList}
          totals={totals} onRefreshClick={onRefreshClick} next={true}
        />
      </div>
    }

    {
      repaymentList && repaymentList.length === 0 &&
      <div className='g_m_top_50'>
        <span className='g_flex_h'><IconButtonUI icon='icon-refresh' onClick={onRefreshClick} /><span/></span>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No loans yet'
        />
      </div>
    }

  </SuperUserPageSF>

export default RepaymentListOldPageUI
